module.exports = __webpack_public_path__ + "old2.jpg?48c5f771e8424357f01b2ba5ef60e800";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old2.jpg
// module id = 80
// module chunks = 0